import * as React from 'react';

import { DimeToggle } from '../DimeToggle.js';
import { TOOLBAR_CONTROL_CLASS } from '../lib/toolbar-control-class.js';
import { cn } from '../lib/utils.js';
import { withToolbarIconProps } from '../lib/with-toolbar-icon-props.js';
import type { DimeActionToolbarIcon } from './DimeActionToolbar.types.js';

type DimeActionToolbarToggleProps = Readonly<
  Omit<React.ComponentProps<typeof DimeToggle>, 'children'> & {
    icon: DimeActionToolbarIcon;
    label: string;
  }
>;

/** The toolbar's stacked icon-over-label look on DimeToggle, for on/off controls such as Search or Show Details. */
export function DimeActionToolbarToggle({
  icon,
  label,
  className,
  ...props
}: DimeActionToolbarToggleProps) {
  return (
    <DimeToggle className={cn(TOOLBAR_CONTROL_CLASS, className)} {...props}>
      {withToolbarIconProps(icon)}
      <span className="text-xs leading-none font-medium">{label}</span>
    </DimeToggle>
  );
}
